module.exports = __webpack_public_path__ + "media/src/images/logo-28fabe3b9263af440c1700c5c75c94b3.png";